import { useTranslation } from "react-i18next";

import { cn } from "@/lib/utils";

export function LogoMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" className={cn("size-8 shrink-0", className)}>
      <rect width="32" height="32" rx="8" className="fill-primary-solid" />
      <path
        d="M8 22V10l8 7 8-7v12"
        fill="none"
        stroke="#fff"
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Logo({ collapsed = false }: { collapsed?: boolean }) {
  const { t } = useTranslation();
  return (
    <span className="flex items-center gap-2.5" aria-label={collapsed ? t("app.name") : undefined}>
      <LogoMark />
      {!collapsed && <span className="text-base font-semibold tracking-tight">{t("app.name")}</span>}
    </span>
  );
}
